const SEARCH_RESULTS = 'SEARCH_RESULTS';
const SEARCH_CLEAR = 'SEARCH_CLEAR';
const SEARCH_ERROR = 'SEARCH_ERROR';

export {SEARCH_CLEAR, SEARCH_RESULTS, SEARCH_ERROR};